import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  CallRecordingControllerApi
} from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  getXtenantId,
  useBaseData,
} from "../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  patientUuid?: string;
  searchString?: string;
}

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useGetTwilioRecordedAudio = ({
  pagination,
  gridSorting,
  patientUuid,
  searchString,
}: Props): useBaseData<any> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;

  return useQuery({
    queryKey: [
      "twilio-recorded-audio",
      pageIndex,
      pageSize,
      sortBy,
      sortDirect,
      patientUuid,
      searchString,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      new CallRecordingControllerApi(getConfigObject())
        .getAllRecording(
          pageIndex,
          pageSize,
          sortBy,
          sortDirect,
          patientUuid,
          searchString,
          getXtenantId()
        )
        .then((res) => res?.data),
  });
};
